import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list"]
  static values = { name: { type: String, default: "" } }

  add(event) {
    if (event.key !== "Enter") return
    event.preventDefault()
    this._addTag()
  }

  addFromButton() {
    this._addTag()
  }

  remove(event) {
    event.target.closest("span").remove()
  }

  _addTag() {
    const value = this.inputTarget.value.trim()
    if (!value) return

    const existing = [...this.listTarget.querySelectorAll("input[type=hidden]")].map(i => i.value)
    if (existing.includes(value)) {
      this.inputTarget.value = ""
      return
    }

    const inputName = this._inputName()
    const span = document.createElement("span")
    span.className = "inline-flex items-center gap-1 rounded-md bg-zinc-100 px-2.5 py-1 text-sm text-zinc-700"
    span.innerHTML = `${this._escapeHtml(value)}<input type="hidden" name="${this._escapeAttr(inputName)}" value="${this._escapeHtml(value)}"><button type="button" data-action="click->tag-input#remove" class="text-zinc-400 hover:text-zinc-600">&times;</button>`
    this.listTarget.appendChild(span)
    this.inputTarget.value = ""
  }

  // Resolves the form param name for new hidden inputs.
  // 1) explicit data-tag-input-name-value="some_model[tags][]"
  // 2) inferred from existing hidden inputs in the list (preserves model-specific names)
  // 3) fallback to legacy "project[tags][]" for backward compat
  _inputName() {
    if (this.nameValue) return this.nameValue

    const existing = this.listTarget.querySelector("input[type=hidden]")
    if (existing && existing.name) return existing.name

    return "project[tags][]"
  }

  _escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }

  _escapeAttr(text) {
    return String(text).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  }
}
